export const RODENT = [
  "Abrocoma",
  "Abrocoma schistacea",
  "Aconaemys",
  "Aconaemys porteri",
  "African brush-tailed porcupine",
  "Andean mountain cavy",
  "Argentine tuco-tuco",
  "Ashy chinchilla rat",
  "Asiatic brush-tailed porcupine",
  "Atherurus",
  "Azara's agouti",
  "Azara's tuco-tuco",
  "Bahia porcupine",
  "Bathyergus",
  "Bathyergus janetta",
  "Bathyergus suillus",
  "Bennett's chinchilla rat",
  "Bicolored-spined porcupine",
  "Black agouti",
  "Black dwarf porcupine",
  "Black-rumped agouti",
  "Black-tailed hairy dwarf porcupine",
  "Bolivian chinchilla rat",
  "Bolivian tuco-tuco",
  "Bonetto's tuco-tuco",
  "Brandt's yellow-toothed cavy",
  "Brazilian guinea pig",
  "Brazilian porcupine",
  "Brazilian tuco-tuco",
  "Bridge's degu",
  "Brown hairy dwarf porcupine",
  "Budin's chinchilla rat, A. budini",
  "Cape porcupine",
  "Catamarca tuco-tuco",
  "Cavia",
  "Central American agouti",
  "Chacoan tuco-tuco",
  "Chilean rock rat",
  "Chinchilla",
  "Coendou",
  "Coiban agouti",
  "Colburn's tuco-tuco",
  "Collared tuco-tuco",
  "Common degu",
  "Common yellow-toothed cavy",
  "Conover's tuco-tuco",
  "Coruro",
  "Crested agouti",
  "Crested porcupine",
  "Cryptomys",
  "Cryptomys bocagei",
  "Cryptomys damarensis",
  "Cryptomys foxi",
  "Cryptomys hottentotus",
  "Cryptomys mechowi",
  "Cryptomys ochraceocinereus",
  "Cryptomys zechi",
  "Ctenomys",
  "Cuniculus",
  "Cuscomys",
  "Cuscomys ashanika",
  "Dactylomys",
  "Dactylomys boliviensis",
  "Dactylomys dactylinus",
  "Dactylomys peruanus",
  "Dasyprocta",
  "Domestic guinea pig",
  "Emily's tuco-tuco",
  "Erethizon",
  "Famatina chinchilla rat",
  "Frosted hairy dwarf porcupine",
  "Fukomys",
  "Fukomys amatus",
  "Fukomys anselli",
  "Fukomys bocagei",
  "Fukomys damarensis",
  "Fukomys darlingi",
  "Fukomys foxi",
  "Fukomys ilariae",
  "Fukomys kafuensis",
  "Fukomys mechowii",
  "Fukomys micklemi",
  "Fukomys occlusus",
  "Fukomys ochraceocinereus",
  "Fukomys whytei",
  "Fukomys zechi",
  "Furtive tuco-tuco",
  "Galea",
  "Georychus",
  "Georychus capensis",
  "Golden viscacha-rat",
  "Goya tuco-tuco",
  "Greater guinea pig",
  "Green acouchi",
  "Haig's tuco-tuco",
  "Heliophobius",
  "Heliophobius argenteocinereus",
  "Heterocephalus",
  "Heterocephalus glaber",
  "Highland tuco-tuco",
  "Hystrix",
  "Indian porcupine",
  "Isla Mocha degu",
  "Kalinowski agouti",
  "Kannabateomys",
  "Kannabateomys amblyonyx",
  "Lagidium",
  "Lagostomus",
  "Lewis' tuco-tuco",
  "Long-tailed chinchilla",
  "Long-tailed porcupine",
  "Los Chalchaleros' viscacha-rat",
  "Lowland paca",
  "Magellanic tuco-tuco",
  "Malayan porcupine",
  "Maule tuco-tuco",
  "Mendoza tuco-tuco",
  "Mexican agouti",
  "Mexican hairy dwarf porcupine",
  "Microcavia",
  "Montane guinea pig",
  "Moon-toothed degu",
  "Mottled tuco-tuco",
  "Mountain degu",
  "Mountain paca",
  "Mountain viscacha-rat",
  "Myoprocta",
  "Natterer's tuco-tuco",
  "North American porcupine",
  "Northern viscacha",
  "Octodon",
  "Octodontomys",
  "Octomys",
  "Olallamys",
  "Olallamys albicauda",
  "Olallamys edax",
  "Orinoco agouti",
  "Paraguaian hairy dwarf porcupine",
  "Pearson's tuco-tuco",
  "Peruvian tuco-tuco",
  "Philippine porcupine",
  "Pipanacoctomys",
  "Plains viscacha",
  "Plains viscacha-rat",
  "Porteous' tuco-tuco",
  "Punta de Vacas chinchilla rat",
  "Red acouchi",
  "Red-rumped agouti",
  "Reddish tuco-tuco",
  "Rio Negro tuco-tuco",
  "Robust tuco-tuco",
  "Roosmalen's dwarf porcupine",
  "Rothschild's porcupine",
  "Ruatan Island agouti",
  "Sage's rock rat",
  "Salinoctomys",
  "Salta tuco-tuco",
  "San Luis tuco-tuco",
  "Santa Catarina's guinea pig",
  "Shiny guinea pig",
  "Shipton's mountain cavy",
  "Short-tailed chinchilla",
  "Silky tuco-tuco",
  "Social tuco-tuco",
  "Southern mountain cavy",
  "Southern tuco-tuco",
  "Southern viscacha",
  "Spalacopus",
  "Spix's yellow-toothed cavy",
  "Steinbach's tuco-tuco",
  "Streaked dwarf porcupine",
  "Strong tuco-tuco",
  "Stump-tailed porcupine",
  "Sumatran porcupine",
  "Sunda porcupine",
  "Talas tuco-tuco",
  "Tawny tuco-tuco",
  "Thick-spined porcupine",
  "Tiny tuco-tuco",
  "Trichys",
  "Tucuman tuco-tuco",
  "Tympanoctomys",
  "Uspallata chinchilla rat",
  "White-toothed tuco-tuco",
  "Wolffsohn's viscacha",
];
